/**
 * Vue Router setup.
 * @see {@link https://router.vuejs.org/api/#router-instance-properties|Vue Router API}
 */
import { createRouter, createWebHistory } from 'vue-router';
import routes from 'routes';
const router = createRouter({
    history: createWebHistory(),
    routes,
});

const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }

    return originalPush.call(this, location).catch((err) => {
        if (err.name === 'NavigationDuplicated') {
            return err;
        }

        return Promise.reject(err);
    });
};

router.afterEach((to, from) => {
    /**
     *
    /**
     * On first route, #legacy-container is not yet compiled by Vue and can not be cached
     * It seems that Vue copies #sellsy-app node so #legacy-container can be cached only after that
     * If it is cached before, our #legacy-container cached is the node before the copy and will not be available when route will change
     * If no route matched, legacy view container should be shown
    */
    const legacy = $('#legacy-container');
    if (router.currentRoute.value.matched.filter((c) => c !== undefined).length > 0) {
        legacy.hide();

        // Remove Page class injected in PHP template when "From" Page is legacy and "To" Page is SPA-compatible.
        if (!!from.fullPath && from.fullPath !== '/' && from.matched.length >= 0) {
            document.body.classList.forEach((className) => {
                if (className.startsWith('page-')) {
                    document.body.classList.remove(className);
                }
            });
        }

        //set title
        if (to.meta['title']) {
            window.document.title = to.meta['title'] + ' - Sellsy';
        } else {
            if (!to.meta['forceTitle']) {
                window.document.title = 'Sellsy';
            }
        }
    } else {
        legacy.show();
    }

    setTimeout(() => {
        window.createUpsellButtons();
    });
});

router.beforeEach((to, from, next) => {
    //avoid errors on same route navigation
    if (to.fullPath === from.fullPath) {
        return;
    }
    //check if route is enabled
    if (to.meta.isEnabled && !to.meta.isEnabled()) {
        throw new Error(
            'Access denied to route ' + to.name + ' because not enabled for current user',
        );
    }

    if (window.kernel.bootData.error && window.kernel.bootData.error.code) {
        delete window.kernel.bootData.error;
        return;
    }

    // Send menu by eventBus
    // Especially for menu.vue to check link active in menu according route active
    setTimeout(() => {
        window.EventBus.emit('main-menu:activeLinkChanged', { activeRoute: to });
    });

    //set menu size
    window.EventBus.emit('main-menu:sizeChanged', { fullMenu: to.meta['fullMenu'] });
    next();

    if (window.Intercom !== undefined) {
        window.Intercom('update');
    }
    if (from && from.meta) {
        to.meta.previousRoute = from.fullPath;
    }
});

export default router;
